import * as React from "react";
import { FaStethoscope } from "react-icons/fa";

const DiagnosticsIcon = ({
    size = 30,
    bg = "#6ea7e8",
    color = "white",
    stroke = "#717272",
    onClick,
}) => {
    return (
        <div
            onClick={onClick}
            style={{
                width: size,
                height: size,
                borderRadius: 6,
                backgroundColor: bg,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                border: `1px solid ${stroke}`,
                cursor: "pointer",
            }}
        >
            <FaStethoscope color={color} size={16} />
        </div>
    );
};

export default DiagnosticsIcon;